exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-attributes .badge {\n  margin: 0px 0px 0px 5px;\n}\n.tab-attributes .sparql-listing {\n  margin-top: 16px;\n}\n.tab-attributes .sparql-listing-entry {\n  color: black;\n}\n.tab-attributes .sparql-listing-entry a {\n  color: black;\n}\n", ""]);

// exports
